import { models } from "types/api/viewModels.ts";

export const formatShippingAddress = (shipTo: models["ShipToViewModel"]): string => {
	const { name, line1, line2, line3, city, state, zip } = shipTo.address ?? {};

	if (!(line1 || line2 || line3) && !city) {
		return "";
	}

	const streetAddress = [line1, line2, line3].filter(Boolean).join(" ").trimEnd();
	return [name?.trim(), `${streetAddress}, ${city}, ${state} ${zip}`].filter(Boolean).join(", ");
};
